import { Grid, Box, styled } from "@mui/material";
export const Header = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  zIndex: 1,
  position: "absolute",
  minHeight: "80px",
  margin: "10px",
  padding: "1px 16px",
  background: "#4EAF50",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "space-between",
  top: 0,
  left: 240,
  right: 0,
  gap: "16px",
  [theme.breakpoints.down("sm")]: {
    background: "#ebebeb",
    top: 60,
    left: 0,
    margin: 0,
  },
}));
export const TableHead = styled(Box)({
  height: "80px",
  display: "grid",
  gridTemplateColumns: "5% 30% 17% 18% 10% 10%",
  borderRadius: "10px",
  margin: "10px",
  backgroundColor: "#4daf51",
  color: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  alignItems: "center",
});
export const BtnBack = styled(Button)({
  textTransform: "none",
  padding: "0px",
  float: "right",
  marginTop: "10px",
  color: "#387E3A",
  size: "12px",
  textDecoration: "underline",
});
export const TableRow = styled(Box)({
  display: "grid",
  height: "70px",
  gridTemplateColumns: "5% 30% 17% 18% 10% 10% 10%",
  borderRadius: "10px",
  margin: "10px",
  backgroundColor: "white",
  color: "black",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
  alignItems: "center",
});
export const SideRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "20px",
});
export const TotalContainer = styled(Grid)({
  backgroundColor: "white",
  borderRadius: "20px",
  margin: "5px",
  padding: "4px",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
  width: "100%",
});
